import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPppBl } from './pages'

type TIdToPageMapWoofzPppBl = Record<PageIdWoofzPppBl, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PPP_BL: TIdToPageMapWoofzPppBl = {
  [PageIdWoofzPppBl.DOG_AGE_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/DogAgePpp').then(
        (m) => ({
          default: m.DogAgePpp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/DogAgePpp'),
  },
  [PageIdWoofzPppBl.DOG_OWNER_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/questions/DogOwnerQuestion'
      ).then((m) => ({
        default: m.DogOwnerQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/DogOwnerQuestion'),
  },
  [PageIdWoofzPppBl.TRAINING_COMMANDS_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/questions/BasicTrainingCommands'
      ).then((m) => ({
        default: m.BasicTrainingCommands,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/questions/BasicTrainingCommands'
      ),
  },
  [PageIdWoofzPppBl.URGE_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp_bl/pages/urge/UrgePage'),
  },
  [PageIdWoofzPppBl.DOG_BREED_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/questions/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/DogBreedQuestion'),
  },
  [PageIdWoofzPppBl.FACING_CHALLENGES_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/questions/FacingChallenges'
      ).then((m) => ({
        default: m.FacingChallenges,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/FacingChallenges'),
  },
  [PageIdWoofzPppBl.FACING_CHALLENGES_2_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/questions/FacingChallengesVersion2'
      ).then((m) => ({
        default: m.FacingChallengesVersion2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/questions/FacingChallengesVersion2'
      ),
  },
  [PageIdWoofzPppBl.BEHAVIOR_FREQUENCY_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/questions/BehaviorFrequency'
      ).then((m) => ({
        default: m.BehaviorFrequency,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/BehaviorFrequency'),
  },
  [PageIdWoofzPppBl.URGE_PROGRAM_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/urge/UrgeProgram').then((m) => ({
        default: m.UrgeProgram,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp_bl/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzPppBl.BEHAVIOR_FEELINGS_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/questions/BehaviorFeelings'
      ).then((m) => ({
        default: m.BehaviorFeelings,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/BehaviorFeelings'),
  },
  [PageIdWoofzPppBl.FIX_BEHAVIOR_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/FixDogBehavior').then(
        (m) => ({
          default: m.FixDogBehavior,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/FixDogBehavior'),
  },
  [PageIdWoofzPppBl.URGE_4_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzPppBl.COMMANDS_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/DogCommands'),
  },
  [PageIdWoofzPppBl.PARENT_GOAL_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/GoalQuestion').then(
        (m) => ({
          default: m.GoalQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/GoalQuestion'),
  },
  [PageIdWoofzPppBl.TRAINING_PLACE_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/TrainingPlace').then(
        (m) => ({
          default: m.TrainingPlace,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/TrainingPlace'),
  },
  [PageIdWoofzPppBl.TRAINING_FREQUENCY_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/TimeQuestion').then(
        (m) => ({
          default: m.TimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/questions/TimeQuestion'),
  },
  [PageIdWoofzPppBl.URGE_5_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/urge/UrgePageVariant5'),
  },
  [PageIdWoofzPppBl.PREPARE_FLOW_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/prepare-flow/PrepareFlowPpp'
      ).then((m) => ({
        default: m.PrepareFlowPpp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/prepare-flow/PrepareFlowPpp'),
  },
  [PageIdWoofzPppBl.COMMITMENT_SCREEN_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/abtest/WoofzCommitment').then(
        (m) => ({
          default: m.WoofzCommitment,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/abtest/WoofzCommitment'),
  },
  [PageIdWoofzPppBl.EMAIL_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/email/EmailPpp').then((m) => ({
        default: m.EmailPpp,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp_bl/pages/email/EmailPpp'),
  },
  [PageIdWoofzPppBl.NEWSLETTER_URGE_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzPppBl.LAST_CHANCE_OFFER_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/last-chance-offer/LastChanceOfferPpp'
      ).then((m) => ({
        default: m.LastChanceOfferPpp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/last-chance-offer/LastChanceOfferPpp'
      ),
  },
  [PageIdWoofzPppBl.SUBSCRIPTIONS_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzPppBl.CHAT_UPSELL_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/upsell/ChatUpsellComponent'
      ).then((m) => ({
        default: m.ChatUpsellComponent,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/upsell/ChatUpsellComponent'),
  },
  [PageIdWoofzPppBl.UPSELL_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp_bl/pages/upsell/Upsell'),
  },
  [PageIdWoofzPppBl.UPSELL_FEEDING_GUIDE_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzPppBl.UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp_bl/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzPppBl.DOWNLOAD_WOOFZ_PPP_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp_bl/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp_bl/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzPppBl.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
